import { render, staticRenderFns } from "./PSelectAgreement.vue?vue&type=template&id=38dfa1ce&scoped=true&"
import script from "./PSelectAgreement.vue?vue&type=script&lang=js&"
export * from "./PSelectAgreement.vue?vue&type=script&lang=js&"
import style0 from "./PSelectAgreement.vue?vue&type=style&index=0&id=38dfa1ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dfa1ce",
  null
  
)

export default component.exports